export const FILTER_VALUES = {
  all: 'all',
  complete: 'complete',
  incomplete: 'incomplete',
  initialValue: 'incomplete',
  overdue: 'overdue'
};